import React, { createContext } from 'react';
import LocationInterface from '@solvhealth/types/interfaces/Location';
import { useCareTeam } from '~/components/CareTeam/hooks/useCareTeam';

export type NearbyLocations = {
  group?: {
    locations: LocationInterface[];
  };
  brand?: {
    locations: LocationInterface[];
  };
  nearby?: LocationInterface[];
  connect?: LocationInterface[];
};

export type LocationContextType = {
  location: LocationInterface;
  associatedTelemedLocation?: LocationInterface;
  nearbyLocations?: NearbyLocations;
  referrerOverridesPause: boolean;
  isFromCareTeam: boolean;
};

export const LocationContext = createContext<LocationContextType>({
  location: {} as LocationInterface,
  associatedTelemedLocation: {} as LocationInterface,
  nearbyLocations: {},
  referrerOverridesPause: false,
  isFromCareTeam: false,
});

export const SessionTrackingContext = createContext({ sessionTrackingProperties: {} });

export const ModalContext = createContext({
  showModal(modalId = '') {},
  hideModal(modalId = '') {},
});

type Props = {
  location?: any;
  associatedTelemedLocation?: any;
  sessionTrackingProperties?: any;
  nearbyLocations?: any;
  showModal: (modalId: string) => void;
  hideModal: (modalId: string) => void;
  children?: React.ReactElement;
  referrerOverridesPause?: boolean;
};

const CDPContextProviders = (props: Props) => {
  const {
    location,
    associatedTelemedLocation,
    nearbyLocations,
    sessionTrackingProperties,
    showModal,
    hideModal,
    children,
    referrerOverridesPause = false,
  } = props;

  const careTeam = useCareTeam();
  const isFromCareTeam = careTeam.allLocations.some((loc) => loc.id === location.id);

  return (
    <SessionTrackingContext.Provider value={{ sessionTrackingProperties }}>
      <LocationContext.Provider
        value={{
          location,
          associatedTelemedLocation,
          nearbyLocations,
          referrerOverridesPause,
          isFromCareTeam,
        }}
      >
        <ModalContext.Provider value={{ showModal, hideModal }}>{children}</ModalContext.Provider>
      </LocationContext.Provider>
    </SessionTrackingContext.Provider>
  );
};

export default CDPContextProviders;
